import { CUSTOM_DOMAINS } from 'src/constants/countries'

export const generateTrustedDomains = () => {
  const testEnv =
    process.env.NEXT_PUBLIC_ENV === 'development' || process.env.NEXT_PUBLIC_ENV === 'test'

  const trustedDomains = [...CUSTOM_DOMAINS, 'www.stayforlong.com']

  if (testEnv) {
    const baseUrl = '{subdomain}.test.s4long.com'
    const possibleSubdomains = [
      'stable',
      'dev',
      ...Array.from({ length: 75 }, (_, i) => String(i + 1)),
    ]

    trustedDomains.push(
      ...possibleSubdomains.map(subdomain => baseUrl.replace('{subdomain}', subdomain)),
      'localhost:3000' // for e2e
    )
  }

  return trustedDomains
}
